module.exports = __webpack_public_path__ + "images/emoji/rice_scene.22c82af2b92ad6cfdf88.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/rice_scene.png
// module id = iVGu
// module chunks = 24